import React from 'react';
import get from 'lodash.get';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { injectIntl, intlShape, defineMessages } from 'react-intl';
import { updateUriRef } from '../../../actions/filterActions';
import { decode64 } from '../../../utils/decode';
import { CURRENCY } from '../../SbSharedRefineMenu/sbSharedRefineMenuConstants';

// components
import { SbSharedRefineMenuInputRadio } from '../SbSharedRefineMenuInput/SbSharedRefineMenuInputRadio';

// Used just for identifying the `all` value, should never be set in the filter store.
function getAllUrlLabel(filterName) {
    return `all ${filterName}`;
}

const { all } = defineMessages({
    all: {
        id: 'sb.SbMobileRefineMenu.radioSelect.all',
        defaultMessage: `{filterName, select,
            location {Anywhere}
            categoryL2 {All {allLabel}}
            categoryL3 {All {allLabel}}
            categoryL4 {All {allLabel}}
            price {Any price}
            priceTrade {Any price}
            other {All}
        }`,
    },
});

function SbSharedRefineMenuRadioSelectComponent(props) {
    const {
        appliedFilterValues,
        valuesToShow,
        filterName,
        intl,
        canBeDismissed,
        allLabel,
        totalCount,
        currency,
    } = props;
    const appliedUrlLabel = get(appliedFilterValues, '0.urlLabel');
    const valuesToShowCopy = [...valuesToShow];

    if (canBeDismissed && valuesToShow.length > 1) {
        valuesToShowCopy.unshift({
            displayName: intl.formatMessage(all, { filterName, allLabel }),
            urlLabel: getAllUrlLabel(filterName),
            checked: !appliedUrlLabel,
            count: totalCount || 0,
            linkReference: get(appliedFilterValues, '0.linkReference'),
            currency,
        });
    }

    return (
        <div>
            {valuesToShowCopy.map(item => {
                const checked = item.checked || item.urlLabel === appliedUrlLabel;

                return (
                    <SbSharedRefineMenuInputRadio
                        key={item.urlLabel}
                        value={item.urlLabel}
                        checked={checked}
                        link={item.link}
                        linkReference={item.linkReference}
                        linkable={item.linkable}
                        onChange={() => props.onChange(item)}
                        text={item.displayName}
                        count={item.count}
                        isHidden={item.isHidden}
                    />
                );
            })}
        </div>
    );
}

SbSharedRefineMenuRadioSelectComponent.propTypes = {
    appliedFilterValues: PropTypes.array.isRequired,
    filterName: PropTypes.string.isRequired,
    valuesToShow: PropTypes.array.isRequired,
    onChange: PropTypes.func.isRequired,
    canBeDismissed: PropTypes.bool.isRequired,
    intl: intlShape.isRequired,
    allLabel: PropTypes.string,
    totalCount: PropTypes.number,
    currency: PropTypes.string,
};

function mapDispatchToProps(dispatch, { filterName }) {
    return {
        onChange(item) {
            const currency = get(item, 'currency');
            const linkReference = get(item, 'linkReference');
            let uriRef = decode64(linkReference);

            if (currency) {
                uriRef = uriRef.replace(`{${CURRENCY}}`, currency.toLowerCase());
            }

            dispatch(updateUriRef({ filterName, filterValue: item, uriRef }));
        },
    };
}

export const SbSharedRefineMenuRadioSelect = connect(
    null,
    mapDispatchToProps
)(injectIntl(SbSharedRefineMenuRadioSelectComponent));
